import { render, staticRenderFns } from "./PlayVideoPopup.vue?vue&type=template&id=011dd89d&scoped=true&"
import script from "./PlayVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./PlayVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PlayVideoPopup.vue?vue&type=style&index=0&id=011dd89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011dd89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011dd89d')) {
      api.createRecord('011dd89d', component.options)
    } else {
      api.reload('011dd89d', component.options)
    }
    module.hot.accept("./PlayVideoPopup.vue?vue&type=template&id=011dd89d&scoped=true&", function () {
      api.rerender('011dd89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/PlayVideoPopup.vue"
export default component.exports